// extracted by mini-css-extract-plugin
module.exports = {"specialization-container":"Specialization_specialization-container__207iu","specialization-title":"Specialization_specialization-title__2Xhm0"};